import React from 'react';
import { alertsForAnswer, proformaAlertNote } from '../../utils/urgentRiskAlerts';

/*
 * UrgentRiskAlertNote (TDI-701)
 *
 * The proforma's small grey note under one respondent's answer, on a row
 * whose question raised an urgent risk alert: when it was sent and, if the
 * answer has changed since, the answer given then. Factual only.
 *
 * Renders nothing when no alert matches the cell's questions and respondent.
 */
export default function UrgentRiskAlertNote({ alerts, questions, role }) {
  const questionIds = (questions || []).map((q) => q?.questionId);
  const matching = alertsForAnswer(alerts, questionIds, role);
  if (!matching.length) return null;
  return (
    <div className="mt-1">
      {matching.map((alert) => (
        <p key={alert.id || `${alert.questionId}-${alert.sentAt}`} className="text-xs text-gray-600">
          {proformaAlertNote(alert)}
        </p>
      ))}
    </div>
  );
}
